import { render, staticRenderFns } from "./b-header.vue?vue&type=template&id=7ed6ac38&scoped=true"
import script from "./b-header.vue?vue&type=script&lang=ts"
export * from "./b-header.vue?vue&type=script&lang=ts"
import style0 from "./b-header.vue?vue&type=style&index=0&id=7ed6ac38&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed6ac38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ed6ac38')) {
      api.createRecord('7ed6ac38', component.options)
    } else {
      api.reload('7ed6ac38', component.options)
    }
    module.hot.accept("./b-header.vue?vue&type=template&id=7ed6ac38&scoped=true", function () {
      api.rerender('7ed6ac38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/biz/b-header.vue"
export default component.exports